import { render } from "./ImportProfileForm.vue?vue&type=template&id=defba360&scoped=true"
import script from "./ImportProfileForm.vue?vue&type=script&lang=js"
export * from "./ImportProfileForm.vue?vue&type=script&lang=js"

import "./ImportProfileForm.vue?vue&type=style&index=0&id=defba360&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-defba360"]])

export default __exports__